import { http } from '@pendo/http';
import uniqBy from 'lodash/uniqBy';

const alertType = 'unmatchedpagesfeatures';
const targetType = 'Application';

export async function fetchSubscriptions () {
    return http
        .get(`/api/s/_SID_/notification/${alertType}`)
        .then((response) => response.data.reduce((current, item) => current.concat(item.targetId), []))
        .catch((error) => {
            throw new Error('Fetch subscription error', error);
        });
}

export async function updateSubscriptions (oldSubscriptions, newSubscriptions) {
    const appIdsToSubscribe = clearAFromBItems(newSubscriptions, oldSubscriptions);
    const appIdsToUnsubscribe = clearAFromBItems(oldSubscriptions, newSubscriptions);
    if (appIdsToSubscribe.length > 0) {
        await subscribe(appIdsToSubscribe);
    }
    if (appIdsToUnsubscribe.length > 0) {
        await unsubscribe(appIdsToUnsubscribe);
    }
}

export function clearAFromBItems (a, b) {
    return a.filter((s) => !b.includes(s)).map((s) => s.toString());
}

export async function subscribe (ids) {
    await http
        .post(`/api/s/_SID_/notification/${alertType}/subscribe`, {
            targetType,
            targetIds: ids,
        })
        .catch((error) => {
            throw new Error('Something went wrong', error);
        });
}

export async function unsubscribe (ids) {
    await http
        .put(`/api/s/_SID_/notification/${alertType}/unsubscribe`, {
            targetType,
            targetIds: ids,
        })
        .catch((error) => {
            throw new Error('Something went wrong', error);
        });
}

export function filterPageFeatureData (value) {
    const filteredPageFeatureAlerts = [];
    const pages = {};
    const brokenFeatures = [];
    value.forEach((row) => {
        row.type = row.featureId ? 'feature' : 'page';
        // find the last app version in production that have views for this page and take the app version and the number of events
        const numEventField = row.type === 'page' ? 'numPageEvents' : 'numFeatureEvents';
        const lastSeenProductionVersion = row.eventsData.find((eventsData) => eventsData[numEventField] > 0);
        row.lastSeenProductionVersion = lastSeenProductionVersion ? lastSeenProductionVersion.appVersion : null;
        row.lastSeenProductionVersionEvents = lastSeenProductionVersion ? lastSeenProductionVersion[numEventField] : 0;

        // set only unique guides in the row
        row.guides = uniqBy(row.guideData, 'guideId').map(({ guideId: id, guideName: name }) => ({ id, name }));

        // Add all pages with no events for current app version.
        if (row.isBrokenFeature) {
            filteredPageFeatureAlerts.push(row);

            return;
        }
        if (row.isBrokenPage) {
            pages[row.pageId] = row;
            filteredPageFeatureAlerts.push(row);
        } else {
            brokenFeatures.push(row);
        }
    });
    brokenFeatures.forEach((row) => {
        const page = pages[row.pageId];
        if (page && !page.children) {
            page.children = [];
        }
        if (page) {
            page.children.push(row);
        }
    });

    return filteredPageFeatureAlerts;
}
